import React from "react";
import { useRoutes } from "react-router-dom";
import AuthLayout from "../views/layouts/AuthLayout";
import MainLayout from "../views/layouts/MainLayout";
import { CONSTANT } from "./Constant";

const PageNotFound = React.lazy(() =>
  import("../views/error_pages/PageNotFound")
);
const Dashboard = React.lazy(() => import("../views/app_pages/Dashboard"));
const Registration = React.lazy(() =>
  import("../views/app_pages/Auth/Registration")
);
const Login = React.lazy(() => import("../views/app_pages/Auth/Login"));
const ForgotPassword = React.lazy(() =>
  import("../views/app_pages/Auth/ForgotPassword")
);
const CandidateList = React.lazy(() =>
  import("../views/app_pages/CandidateList")
);
const User = React.lazy(() => import("../views/app_pages/User"));
const Role = React.lazy(() => import("../views/app_pages/Role"));
const FormVerification = React.lazy(() =>
  import("../views/app_pages/FormVerification")
);
const CandidateDetail = React.lazy(() =>
  import("../views/app_pages/CandidateDetail")
);
const Message = React.lazy(() => import("../views/app_pages/Message"));
const Framework = React.lazy(() => import("../views/app_pages/Framework"));
const Document = React.lazy(() => import("../views/app_pages/Document"));
const FormMaster = React.lazy(() => import("../views/app_pages/Form"));
const ExpiryDetailList = React.lazy(() =>
  import("../views/app_pages/Dashboard/ExpiryDetailList")
);
const Unauthorized = React.lazy(() =>
  import("../views/error_pages/Unauthorized")
);

export default function Router() {
  const element = useRoutes(RouterConfig);
  return element;
}

export const RouterConfig = [
  {
    element: <AuthLayout />,
    children: [
      {
        path: CONSTANT.LOGIN_REDIRECT_PATH,
        element: <Login />,
      },
      {
        path: CONSTANT.ROUTE.REGISTER,
        element: <Registration />,
      },
      {
        path: CONSTANT.ROUTE.FORGOT_PASSWORD,
        element: <ForgotPassword />,
      },
      {
        path: CONSTANT.ROUTE.UNAUTHORIZED,
        element: <Unauthorized />,
      },
      {
        path: "*",
        element: <PageNotFound />,
      },
    ],
  },
  {
    element: <MainLayout />,
    children: [
      // {
      //   path: CONSTANT.ROUTE.PROFILE,
      //   element: <MyProfile />,
      // },
      {
        path: CONSTANT.ROUTE.CANDIDATE_LIST,
        element: <CandidateList />,
      },
      {
        path: CONSTANT.ROUTE.USER,
        element: <User />,
      },
      {
        path: CONSTANT.ROUTE.VERIFICATION,
        element: <FormVerification />,
      },
      {
        path: CONSTANT.ROUTE.CANDIDATE_DETAIL,
        element: <CandidateDetail />,
      },
      {
        path: CONSTANT.ROUTE.ROLE,
        element: <Role />,
      },
      {
        path: CONSTANT.ROUTE.MESSAGE,
        element: <Message />,
      },
      {
        path: CONSTANT.ROUTE.FRAMEWORK,
        element: <Framework />,
      },
      {
        path: CONSTANT.ROUTE.DASHBOARD,
        element: <Dashboard />,
      },
      {
        path: CONSTANT.ROUTE.EXPIRY_DETAIL,
        element: <ExpiryDetailList />,
      },
      {
        path: CONSTANT.ROUTE.DOCUMENT,
        element: <Document />,
      },
      {
        path: CONSTANT.ROUTE.FORM,
        element: <FormMaster />,
      },
      {
        path: "*",
        element: <PageNotFound />,
      },
    ],
  },
];
